import { render, staticRenderFns } from "./SpotPage.vue?vue&type=template&id=9927ca0c&scoped=true"
import script from "./SpotPage.vue?vue&type=script&lang=js"
export * from "./SpotPage.vue?vue&type=script&lang=js"
import style0 from "./SpotPage.vue?vue&type=style&index=0&id=9927ca0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9927ca0c",
  null
  
)

export default component.exports